import { render, staticRenderFns } from "./DeanAdmissionsJournalView.vue?vue&type=template&id=fe054fbc"
import script from "./DeanAdmissionsJournalView.vue?vue&type=script&lang=js"
export * from "./DeanAdmissionsJournalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports